import { render, staticRenderFns } from "./FacilityEditTabClient.vue?vue&type=template&id=8a26bc52&"
import script from "./FacilityEditTabClient.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports